module.exports = __webpack_public_path__ + "img/375_news_sub_img3.cedb0225.png";